import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CURRENT_USER } from '../services/local-storage.service';
import { UserProfileService } from '../services/user-profile.service';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const AuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userProfile = inject(UserProfileService);

  const userData = localStorage.getItem(CURRENT_USER);
  // console.log('AuthGuard checking CURRENT_USER →', userData);

  if (!userData) {
    router.navigate(['/login']);
    return of(false);
  }

  // Setare user curent
  const user = JSON.parse(userData);
  userProfile.currentUser$.next(user);

  // Asteptare incarcare permisiuni
  return userProfile.loadPermissions().pipe(
    switchMap(success => {
      if (!success) {
        router.navigate(['/login']);
        return of(false);
    }
      return of(true);
    })
  );
};